<template>
    <div class="filter-row">
        <date-picker @changed="onDateChangeHandler" class="picker" />
        <base-filter btn-filter-id="btn-talk-filter" v-slot="{ hideContent }">
            <div class="title-row">
                <h5 class="title">{{ $t('values.filters') }}</h5>
            </div>
            <div>
                <users-filter @changed="selectedUsersHandler" />
                <admin-filter v-if="isAdminTab" @changed="onAdminChangedHanlder" />
                <bulk-search v-if="isManagerTab || isAdminTab" @changed="onChangedBulkHandler" />
                <b-form-checkbox v-model="withArchived" @change="onWithArchivedChange">{{
                    $t('form.button.showArchivedFeedbacks')
                }}</b-form-checkbox>
                <div class="footer d-flex justify-content-end">
                    <b-button
                        variant="primary"
                        @click="
                            () => {
                                applyUsersFilters()
                                hideContent()
                            }
                        "
                        >{{ $t('form.button.filter') }}</b-button
                    >
                </div>
            </div>
        </base-filter>
    </div>
</template>
<script>
import { EventBuzz } from '@/main'
import BaseFilter from '@/views/components/filters'
import { UsersFilter, BulkSearch, AdminFilter } from './components'
import { DatePicker } from '@/views/components/date'

export default {
    name: 'Filters',
    components: {
        DatePicker,
        BaseFilter,
        UsersFilter,
        BulkSearch,
        AdminFilter,
    },
    props: {
        selectedRoleTab: {
            type: String,
            default: 'user',
        },
    },
    data() {
        return {
            filters: {},
            isLoading: false,
            hide: false,
            receivers: null,
            senders: null,
            bulkSearch: null,
            withArchived: false,
        }
    },
    methods: {
        emitChanged() {
            this.$emit('changed', this.filters)
            EventBuzz.$emit('feedback-filters-changed', this.filters)
        },
        onWithArchivedChange(withArchived) {
            this.filters = {
                ...this.filters,
                withArchived,
            }
        },
        formatDateToYYYYMMDD(date) {
            return date.toISOString().split('T')[0]
        },
        onDateChangeHandler({ start, end }) {
            start = this.formatDateToYYYYMMDD(start)
            end = this.formatDateToYYYYMMDD(end)
            this.filters = {
                ...this.filters,
                start,
                end,
            }
            this.emitChanged()
        },
        selectedUsersHandler({ senders, receivers }) {
            this.senders = senders
            this.receivers = receivers
        },
        applyUsersFilters() {
            this.filters = {
                ...this.filters,
                senders: this.senders,
                receivers: this.receivers,
                bulkSearch: this.bulkSearch,
                withArchived: this.withArchived,
            }

            this.emitChanged()
        },
        onChangedBulkHandler(bulkSearch) {
            this.bulkSearch = bulkSearch
        },
        onAdminChangedHanlder({ departments, managers, occupationGroups, questionnaires }) {
            this.filters = {
                ...this.filters,
                departments,
                managers,
                occupationGroups,
                questionnaires,
            }
        },
    },
    computed: {
        isAdminTab() {
            return this.selectedRoleTab === 'administrator'
        },
        isManagerTab() {
            return this.selectedRoleTab === 'manager'
        },
    },
}
</script>

<style lang="sass" scoped>
.filter-row
    display: flex
    justify-content: space-between
    align-items: center
    .picker
        margin-right: 40px
.filter-container

    padding: 5px
    width: 100%

::v-deep
    .filter-fields
        max-height: 600px
        overflow-y: auto
</style>
